import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RoutePath } from 'src/app/shared/route';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAdmin$.pipe(
    take(1),
    map((isAdmin) => {
      if (!isAdmin) return router.createUrlTree(RoutePath.getPath('auth/signin').generate());

      return isAdmin;
    }),
  );
};
